var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.001,
    height: 12.187,
    viewBox: "0 0 12.001 12.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-link",
    "data-name": "Icon feather-link",
    transform: "translate(-2.493 -2.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M15,9.052a2.749,2.749,0,0,0,4.145.3L20.795,7.7a2.749,2.749,0,1,0-3.887-3.887l-.945.94",
    transform: "translate(-7.606)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M9.593,14.595a2.749,2.749,0,0,0-4.145-.3L3.8,15.947a2.749,2.749,0,1,0,3.887,3.887l.94-.94",
    transform: "translate(0 -6.642)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherLink);
export default __webpack_public_path__ + "static/media/Icon-feather-link.b9a2ae34fde7aaa98c2e4b528ecb389d.svg";
export { ForwardRef as ReactComponent };